import { useAuthContext } from 'HOC/withAuth';
import { TCountryCode } from 'modules/Business/shared/typesTS';

interface OnlyGBContentBoxProps {
  children: JSX.Element;
  country: TCountryCode;
}

const CountrySpecificBox = ({ children, country }: OnlyGBContentBoxProps): JSX.Element => {
  const { user: auth } = useAuthContext();
  const countryCode = auth?.locale?.countryCode;
  const isAllowedCountry = countryCode === country;

  return isAllowedCountry ? children : <></>;
};

export default CountrySpecificBox;
